module.exports = __webpack_public_path__ + "images/niab-cuf-logo_thumbnail_06f62402c992b99d0232c83ee0a10e71.png";